// Parse and organize custom attributes based on AI SDK telemetry structure
export const parseCustomAttributes = (attributes: Record<string, unknown>) => {
  const groups: Record<string, Record<string, unknown>> = {};

  for (const [key, value] of Object.entries(attributes)) {
    const parts = key.split(".");
    if (parts.length >= 2) {
      const [namespace, category, ...rest] = parts;
      const groupKey = `${namespace}.${category}`;
      const fieldKey = rest.length > 0 ? rest.join(".") : category;

      if (!groups[groupKey]) {
        groups[groupKey] = {};
      }
      groups[groupKey][fieldKey] = value;
    } else {
      // Handle single-level attributes
      if (!groups.other) {
        groups.other = {};
      }
      groups.other[key] = value;
    }
  }

  return groups;
};

// Get friendly names for attribute groups
export const getGroupDisplayName = (groupKey: string): string => {
  const groupNames: Record<string, string> = {
    "ai.model": "AI Model",
    "ai.settings": "AI Settings",
    "ai.usage": "Token Usage",
    "ai.request": "Request Info",
    "ai.response": "Response Info",
    "ai.telemetry": "Telemetry",
    "ai.prompt": "Prompt",
    "gen_ai.request": "Request",
    "gen_ai.response": "Response",
    "gen_ai.system": "System",
    operation: "Operation",
    resource: "Resource",
    other: "Other",
  };
  return groupNames[groupKey] || groupKey;
};
